import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import ContentWrapper from '../ContentWrapper';
import FormCard from '../FormCard';
import Insurance from './components/Insurance';
import { useInsuranceInfo } from 'hooks/newUniprofile/useInsuranceInfo';
import { Spin } from 'antd';

interface InsuranceStepProps {
    isReview?: boolean;
}

const InsuranceStep = forwardRef(({ isReview = false }: InsuranceStepProps, ref) => {
    const insuranceFormRef = useRef();
    const [insuranceInfo, loading, refetch] = useInsuranceInfo();
    console.log('insuranceInfo', insuranceInfo);

    const onSubmit = async () => {
        try {
            if (insuranceFormRef.current) {
                await insuranceFormRef.current.onSubmit();
            }
        } catch (error) {
            console.error('Form save failed:', error);
            throw error;
        }
    };

    useImperativeHandle(ref, () => ({
        onSubmit,
    }));

    return (
        <Spin spinning={loading}>
            <ContentWrapper title="Insurance" description="Select the payment and insurance types you support." showInfo={!isReview}>
                <FormCard
                    type={isReview ? 'review' : 'edit'}
                    title="Insurance"
                    showHeader={isReview}
                    onSave={onSubmit}
                    ref={insuranceFormRef}
                >
                    {(isEditing) =>
                        <Insurance
                            editable={isEditing}
                            initFormValue={insuranceInfo}
                            refetch={refetch}
                        />}
                </FormCard>
            </ContentWrapper>
        </Spin>
    );
});

export default InsuranceStep;
